import { PLAN_TRIAL } from '@app/features/subscription/constants';

function isTrialPlan(planId: string | undefined | null) {
  return planId === PLAN_TRIAL;
}

export default isTrialPlan;
